import React from 'react'
import { BasicCrossSell } from 'components/layout'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { chooseAppropriateProduct, Product } from 'services/ContentfulService/models/product'
import { LearnProductHero } from './Hero'
import { Topic } from 'services/ContentfulService/models/topics'
import { TopicsSection } from '../topics/TopicsSection'
import { ApplySection } from '../common/applySection'
import { FaqSection } from 'experiences/learn/common/FaqSection/FaqSection'
import { FAQ } from 'services/ContentfulService/models/fact'
import { PartnerSection } from '../partners/PartnersSection'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { truncArray } from 'lib'
import { LearnContainer } from '../common'
import { PrioritizedContent } from 'experiences/shared/ContentfulImage/PriorityContext'
import { ArticleSection } from 'experiences/shared/ArticleSection'

interface Props {
	articles: ArticleSummary[]
	faqs: FAQ[]
	partners: Partner[]
	selectedProduct: Product
	products: Product[]
	relatedTopics: Topic[]
	latestArticles: ArticleSummary[]
}

export const LearnProductPage = ({
	articles,
	selectedProduct,
	products,
	relatedTopics,
	latestArticles,
	partners,
	faqs
}: Props): JSX.Element => (
	<div>
		<LearnProductHero selectedProduct={selectedProduct} products={products} />
		<LearnContainer>
			{/*<BeginnersGuideCard />*/}
			<PrioritizedContent>
				<ArticleSection articles={truncArray(articles, 3)} title="Top Articles" linkTo="/learn/articles" />
			</PrioritizedContent>
			{relatedTopics.length >= 2 && (
				<TopicsSection topics={truncArray(relatedTopics, 4)} title="Related Topics" linkTo="/learn/topics" />
			)}
			<FaqSection faqs={faqs} />
			<BasicCrossSell product={chooseAppropriateProduct({ products: [selectedProduct] })} />
			{partners.length > 2 && <PartnerSection product={selectedProduct} partners={partners} />}
			<ArticleSection
				articles={latestArticles.slice(0, 8)}
				title="Latest Articles"
				linkTo="/learn/articles"
				isSmallCard
			/>
		</LearnContainer>
		<ApplySection />
	</div>
)
